module.exports = __webpack_public_path__ + "static/headerGI2-5b1682f783605a89202d221d754f9089.jpg";